import Backbone from 'backbone'

/**
 * Model representing a user's public API token. See UserApiToken.kt
 */
const ApiToken = Backbone.Model.extend({
})

export default ApiToken

ApiToken.__filename__ = 'admin/api-tokens/api-token.js'
